import styled from 'styled-components';

export const Tabs = {
    Container: styled.div`
        padding:10px;
    `,
    Wrapper: styled.div`
        display: flex;
        flex-direction: row;
        gap: 5px;

        button{
            border-radius:90px;
            width: 80px;
            font-size: 12px;
            height: 30px;
            color: #000000;

            &.active{
                background: #000;
                color: #fff;
            }
        }
    `,
}